import { SETTINGS_IMPORT_SECTION_DATA } from '@webapp/containers/SettingsImport/constants'
import { useProcurifyIntl } from '@webapp/hooks'
import { LegacyImporter } from '@webapp/platform/_unmigrated/Importer'
import messages from './messages'

export interface BudgetCategoryImporterProps {
  handleModalClose: () => void
}

export const BudgetCategoryImporter = ({
  handleModalClose,
}: BudgetCategoryImporterProps) => {
  const intl = useProcurifyIntl()

  return (
    <LegacyImporter
      title={intl.formatMessage(messages.importerTitle)}
      type={SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.type}
      onDismiss={handleModalClose}
      {...SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.importerOptions}
    />
  )
}
